import { UserComponent } from "@cmp-src/components/WeeklyOffice/cells/UserCell";
import { AuthenticatedUser } from "@gettactic/api";
import { Skeleton } from "@cmp-src/primitives/skeleton";
import { memo } from "react";

export const WeeklyTableSkeleton = memo(
  ({
    columnCount = 8,
    myUser
  }: {
    columnCount?: number;
    myUser?: AuthenticatedUser["user"];
  }) => {
    // Cell styling for name column vs day columns
    const getNameCellStyle = () => ({
      width: "100%",
      height: "100%",
      margin: 0,
      padding: "0px",
      display: "flex",
      alignItems: "center"
    });

    const getDayCellStyle = () => ({
      width: "100%",
      height: "100%",
      margin: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    });

    return (
      <>
        {/* First cell is the name column */}
        <div className="overflow-hidden h-full" style={getNameCellStyle()}>
          {myUser ? (
            <UserComponent user={myUser} isMe={true} hasAnyFav={false} />
          ) : (
            <Skeleton className="h-8 min-h-[36px] w-full rounded-xl" />
          )}
        </div>
        {/* Create skeleton cells for each day column */}
        {Array.from({ length: columnCount - 1 }).map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <It's ok for a skeleton>
          <div
            key={`skeleton-${index}`}
            style={getDayCellStyle()}
            className="overflow-hidden h-full"
          >
            <div className="w-full">
              <Skeleton className="h-8 min-h-[36px] w-full animate-pulse rounded-xl bg-neutral-200" />
            </div>
          </div>
        ))}
      </>
    );
  }
);
